import { updateCharacter } from 'app/frontend/base/api/character'
import { useApplicationDetails } from 'app/frontend/base/config/queries'
import { useRefreshCharacterDetails } from 'app/frontend/base/hooks/useRefreshCharacterDetails'
import { Loader2, RefreshCwIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

type Props = {
  character: wowaudit.CharacterReference
  callback: () => void
  team?: wowaudit.Team
}

const RefreshCharacterIcon = ({ character, callback, team }: Props) => {
  const { applicationId } = useParams()
  const { data: application } = useApplicationDetails(
    team?.id,
    applicationId ? parseInt(applicationId) : undefined,
  )

  const { refreshing, refreshData } = useRefreshCharacterDetails(character, {
    retriever: updateCharacter,
    id: character?.id,
    params: {
      team_id: team?.id.toString() ?? '',
      wcl_role: application?.role ?? 'damage',
    },
    successKey: 'dashboard.character.character-update-success',
    callback,
  })

  if (refreshing) {
    return <Loader2 className='w-4 h-4 animate-spin' />
  }

  return (
    <RefreshCwIcon
      className='w-4 h-4 cursor-pointer'
      onClick={() => refreshData()}
    />
  )
}

export default RefreshCharacterIcon
